import { useAppSelector } from "features/store";
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

type CalibrateAdminRouteProps = {
  children: ReactNode;
};

const CalibrateAdminRoute = ({ children }: CalibrateAdminRouteProps): JSX.Element => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user && !user.is_pass_reset) {
    return <Navigate to="/reset-password" replace />;
  }

  // Allow either Calibrate Admin or Super Admin to access this route.
  if (!user || (!user.is_calibrate_admin && !user.is_superuser)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default CalibrateAdminRoute;
